import { createSelector } from '@ngrx/store';
import { DropzonesState, selectDropzonesState } from '../dropzones.state';

export const selectDropzones = createSelector(selectDropzonesState, (state: DropzonesState) => state.items);
export const selectDropzonesUserNear = createSelector(selectDropzonesState, (state: DropzonesState) => state.userNear);
